import type { ReactNode } from 'react';

interface HorizontalScrollProps {
  children: ReactNode;
  className?: string;
}

export function HorizontalScroll({ children, className = '' }: HorizontalScrollProps) {
  return (
    <div
      className={className}
      role="region"
      aria-label="Horizontally scrollable content"
      tabIndex={0}
      style={{
        display: 'flex',
        gap: 'var(--space-4)',
        overflowX: 'auto',
        scrollSnapType: 'x mandatory',
        WebkitOverflowScrolling: 'touch',
        paddingBottom: 'var(--space-4)',
        scrollbarWidth: 'none',
      }}
    >
      {children}
      <style>{`
        .${className || 'h-scroll'}::-webkit-scrollbar { display: none; }
      `}</style>
    </div>
  );
}
